<!-- TODO: API 연동 -->
<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">AI 예약 상세 설정</span>
                <button class="mgl_auto" @click="action_Close"><v-icon large>mdi-close</v-icon></button>
            </div>
            <div class="pop_cont">
                <!-- 예약 가능 기간 -->
                <ul class="form_list">
                    <li class="title">
                        예약 가능 기간
                        <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                        <span class="tooltip_wrap">
                            <span class="tooltip">현재 시점을 기준으로 최소/최대 예약 가능 시점을 설정할 수 있습니다. <br />당일 예약을 막거나, 너무 먼 미래의 예약을
                                등록하는 것을 방지할 수 있습니다.</span>
                        </span>
                    </li>
                    <li class="cont">
                        <div class="inline_form">
                            <span>현재 기준</span>
                            <select class="input_xs" v-model="column.aiSameDayBlockDuration">
                                <option v-for="n in startValueOptions" :key="n" :value="n - 1">{{ n - 1 }}</option>
                            </select>
                            <select class="input_xs" v-model="column.aiSameDayBlockType">
                                <option value="day">일</option>
                                <option value="hour">시간</option>
                            </select>
                            <span>이후부터</span>
                            <select class="input_xs" v-model="column.aiPossibleCreateRange">
                                <option v-for="n in 90" :key="n" :value="n">+{{ n }}</option>
                            </select>
                            <span>일 까지 예약 등록 가능</span>
                        </div>
                    </li>
                </ul>
                <!-- 예약 시간 간격 -->
                <ul class="form_list">
                    <li class="title">
                        예약 시간 간격
                        <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                        <span class="tooltip_wrap">
                            <span class="tooltip">설정된 시간 간격으로 예약을 등록합니다.</span>
                        </span>
                    </li>
                    <li class="cont">
                        <div class="form_list">
                            <select class="input_xs w_full" v-model="column.aiAppInterval"
                                :disabled="!column.aiUsingDefaultAppInterval">
                                <option :value="5">5분</option>
                                <option :value="10">10분</option>
                                <option :value="15">15분</option>
                                <option :value="20">20분</option>
                                <option :value="25">25분</option>
                                <option :value="30">30분</option>
                                <option :value="35">35분</option>
                                <option :value="40">40분</option>
                                <option :value="45">45분</option>
                                <option :value="50">50분</option>
                                <option :value="55">55분</option>
                                <option :value="60">1시간</option>
                                <option :value="90">1시간30분</option>
                                <option :value="120">2시간</option>
                            </select>
                            <label class="check_wrap">
                                <input type="checkbox" :checked="!column.aiUsingDefaultAppInterval"
                                    @change="column.aiUsingDefaultAppInterval = !$event.target.checked">
                                <span class="checkmark"></span>
                                직접선택
                            </label>
                        </div>

                        <div class="table2_xyscroll sticky" style="height: 180px;"
                            v-if="!column.aiUsingDefaultAppInterval">
                            <table class="table2_default pd_small">
                                <thead>
                                    <tr>
                                        <th style="width: 220px;">시간 간격</th>
                                        <th>삭제</th>
                                    </tr>
                                </thead>
                                <tbody v-if="(column.aiAppTimeIntervals?.length ?? 0) == 0">
                                    <tr>
                                        <td class="txt_center lgray_txt" colspan="2">기준을 추가해 주세요.</td>
                                    </tr>
                                </tbody>
                                <tbody v-if="(column.aiAppTimeIntervals?.length ?? 0) > 0">
                                    <tr v-for="(t, index) in column.aiAppTimeIntervals" :key="index">
                                        <td>
                                            <select class="input_xs" :value="getHour(t)"
                                                @change="updateHour(index, $event.target.value)">
                                                <option v-for="h in 24" :key="h" :value="h - 1">{{ formatTime(h - 1) }}
                                                </option>
                                            </select>
                                            <select class="input_xs" :value="getMinute(t)"
                                                @change="updateMinute(index, $event.target.value)">
                                                <option v-for="m in 12" :key="m" :value="(m - 1) * 5">{{ formatTime((m -
                                                    1) * 5) }}</option>
                                            </select>
                                        </td>
                                        <td class="txt_left">
                                            <button class="btn btn_s btn_dgray" @click="action_RemoveItem(index)">－ 삭제</button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td class="txt_center" colspan="2">
                                        <button class="btn btn_s btn_blue_line" @click="action_AddInterval">＋
                                            추가</button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <small class="red_txt" v-if="isErrorInterval">표시 기준을 최소 1개 이상 입력해 주세요.</small>
                        <small class="red_txt" v-if="isErrorDuplicatedInterval">같은 시간으로 입력된 항목이 있습니다.</small>
                    </li>
                </ul>
                <!-- 시간당 가예약 가능 인원 -->
                <ul class="form_list">
                    <li class="title">
                        시간당 가예약 가능 인원
                        <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                        <span class="tooltip_wrap">
                            <span class="tooltip">시간당 가예약 가능한 최대 인원 수를 설정할 수 있습니다. 고객이 희망하는 시간대에 정원 초과 시 다른 시간대를
                                안내합니다.</span>
                        </span>
                    </li>
                    <li class="cont">
                        <div class="inline_form">
                            <select class="input_s" v-model="column.aiAppMaxCapacity" style="width: 100%;">
                                <option v-for="n in 30" :key="n" :value="n">{{ n }}명</option>
                            </select>
                        </div>
                    </li>
                </ul>
                <div class="btn_wrap">
                    <button class="btn btn_l btn_dgray" @click="action_Close">{{ $t('common.cancel') }}</button>
                    <button class="btn btn_l btn_blue" @click="action_Save">{{ $t('common.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useQueryClient } from '@tanstack/vue-query'
import { reservationColumnAiFindQueryOptions } from '@/composables/queries/reservationcolumn/use-reservation-column-ai-find-query'
import { useReservationColumnAiUpdateMutation } from '@/composables/queries/reservationcolumn/use-reservation-column-ai-update-mutation'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: mutateAiColumn } = useReservationColumnAiUpdateMutation()
        return { queryClient, mutateAiColumn }
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isLoading: false,
            column: {},

            isErrorInterval: false,
            isErrorDuplicatedInterval: false,
        }
    },
    computed: {
        startValueOptions: function () {
            // 일이면 0-31 (32개), 시간이면 0-24 (25개)
            return this.startUnit === 'day' ? 32 : 25
        },
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue) {
                    this.column = {}
                    this.loadColumn()
                }
            }
        },
    },
    methods: {
        action_Close() {
            this.$emit('close')
        },
        async action_Save() {
            try {
                await this.mutateAiColumn({
                    _id: this.column._id,
                    hospitalID: this.column.hospitalID,
                    aiSameDayBlockType: this.column.aiSameDayBlockType,
                    aiSameDayBlockDuration: this.column.aiSameDayBlockDuration,
                    aiPossibleCreateRange: this.column.aiPossibleCreateRange,
                    aiUsingDefaultAppInterval: this.column.aiUsingDefaultAppInterval,
                    aiAppInterval: this.column.aiAppInterval,
                    aiAppTimeIntervals: this.column.aiAppTimeIntervals,
                    aiAppMaxCapacity: this.column.aiAppMaxCapacity,
                })
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            this.action_Close()
        },

        action_AddInterval() {
            if (this.column.aiAppTimeIntervals === undefined) {
                this.column.aiAppTimeIntervals = []
            }
            this.column.aiAppTimeIntervals.push('00:00')
            this.isErrorInterval = false
            this.isErrorDuplicatedInterval = false
        },
        action_RemoveItem(index) {
            this.column.aiAppTimeIntervals.splice(index, 1)
            this.isErrorInterval = false
            this.isErrorDuplicatedInterval = false
        },

        // MARK: - Network
        async loadColumn() {
            this.isLoading = true
            const hospitalID = this.hospital.selectedHospital._id
            try {
                this.column = await this.queryClient.fetchQuery(reservationColumnAiFindQueryOptions({ hospitalID: hospitalID }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 column 을 비운다 (레거시는 undefined 대입)
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                this.column = undefined
            }
            this.isLoading = false
        },

        // MARK: - TimeCalc
        getHour(t) {
            const parts = t.split(':')
            return parseInt(parts[0], 10)
        },
        getMinute(t) {
            const parts = t.split(':')
            return parseInt(parts[1], 10)
        },

        updateHour(index, hour) {
            const currentMinute = this.getMinute(this.column.aiAppTimeIntervals[index])
            const newTime = `${this.formatTime(hour)}:${this.formatTime(currentMinute)}`
            this.column.aiAppTimeIntervals.splice(index, 1, newTime)
            this.isErrorInterval = false
            this.isErrorDuplicatedInterval = false
        },
        updateMinute(index, minute) {
            const currentHour = this.getHour(this.column.aiAppTimeIntervals[index])
            const newTime = `${this.formatTime(currentHour)}:${this.formatTime(minute)}`
            this.column.aiAppTimeIntervals.splice(index, 1, newTime)
            this.isErrorInterval = false
            this.isErrorDuplicatedInterval = false
        },
        formatTime(value) {
            return value < 10 ? '0' + value : value
        },
    }
}
</script>

<style scoped>
.pop_wrap.rsv2_manager_set_pop {
    width: 720px;
}

.inline_form {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.inline_form select {
    width: auto;
    min-width: 60px;
}

.form_list .cont .form_list {
    display: flex;
    align-items: center;
    gap: 10px;
}

.form_list .cont .form_list select {
    flex: 1;
}

.form_list li.title {
    flex-basis: 180px !important;
}

.btn_wrap {
    padding-top: 320px !important;
}
</style>
